import AcceptInvitation, {
  loader as acceptInvitationLoader,
} from '../pages/teams/AcceptInvitation';

export const teamsRoutes = [
  {
    path: '/invitation/:invitationId',
    element: <AcceptInvitation />,
    loader: acceptInvitationLoader,
  },
];
